import { StandardConfigurationDetailBase } from './base/standard-configuration-detail-base';

export class StandardConfigurationDetail extends StandardConfigurationDetailBase { }